import AppIcon from "@/components/AppIcon";
import PercentageValue from "@/components/tableElements/PercentageValue";
import { CurrencyValue, DateValue } from "@/components/tableElements";
export default {
  name: "PpcStrategyShadowRow",
  components: {
    AppIcon,
    PercentageValue,
    CurrencyValue,
    DateValue
  },
  props: {
    week: {
      type: Object,
      required: true
    },
    shadow: {
      type: Object,
      default: null
    },
    rowName: {
      type: String,
      required: true
    },
    currency: {
      type: String
    },
    rowClassName: {
      type: Function,
      required: true
    },
    onEnter: {
      type: Function,
      required: true
    }
  }
};